<template>
    <div class="relative">
        <input
            v-model.trim="id"
            autocomplete="off"
            type="text"
            name="id"
            class="rounded h-12 text-sm placeholder-gray-500 px-4 rounded-xl border border-gray-200 w-full py-2 focus:outline-none focus:border-blue-400"
            placeholder="id"
        >
    </div>
    <div class="relative">
        <input
            v-model.trim="aplCatl"
            autocomplete="off"
            type="text"
            name="aplCatl"
            class="rounded h-12 text-sm placeholder-gray-500 px-4 rounded-xl border border-gray-200 w-full py-2 focus:outline-none focus:border-blue-400"
            placeholder="aplCatl"
        >
    </div>
    <div class="relative">
        <input
            v-model.trim="source"
            autocomplete="off"
            type="text"
            name="source"
            class="rounded h-12 text-sm placeholder-gray-500 px-4 rounded-xl border border-gray-200 w-full py-2 focus:outline-none focus:border-blue-400"
            placeholder="source"
        >
    </div>
    <div class="relative">
        <input
            v-model.trim="sysAuthCode"
            autocomplete="off"
            type="text"
            name="sysAuthCode"
            class="rounded h-12 text-sm placeholder-gray-500 px-4 rounded-xl border border-gray-200 w-full py-2 focus:outline-none focus:border-blue-400"
            placeholder="sysAuthCode"
        >
    </div>
    <div class="relative">
        <input
            v-model.trim="transactionItemNo"
            autocomplete="off"
            type="text"
            name="transactionItemNo"
            class="rounded h-12 text-sm placeholder-gray-500 px-4 rounded-xl border border-gray-200 w-full py-2 focus:outline-none focus:border-blue-400"
            placeholder="transactionItemNo"
        >
    </div>
    <div class="relative">
        <input
            v-model.trim="policySeq"
            autocomplete="off"
            type="text"
            name="policySeq"
            class="rounded h-12 text-sm placeholder-gray-500 px-4 rounded-xl border border-gray-200 w-full py-2 focus:outline-none focus:border-blue-400"
            placeholder="policySeq"
        >
    </div>
    <div class="relative">
        <input
            v-model.trim="idDup"
            autocomplete="off"
            type="text"
            name="idDup"
            class="rounded h-12 text-sm placeholder-gray-500 px-4 rounded-xl border border-gray-200 w-full py-2 focus:outline-none focus:border-blue-400"
            placeholder="idDup"
        >
    </div>
    <div class="relative">
        <input
            v-model.trim="policyNo"
            autocomplete="off"
            type="text"
            name="policyNo"
            class="rounded h-12 text-sm placeholder-gray-500 px-4 rounded-xl border border-gray-200 w-full py-2 focus:outline-none focus:border-blue-400"
            placeholder="policyNo"
        >
    </div>
    <div class="flex justify-center pt-2">
        <button
            class="btn w-full rounded-full gradient-primary border-0 max-w-[8.75rem]"
            @click.prevent="postApi"
        >
            確定
        </button>
    </div>
    <Loading :isLoading="isLoading" />
</template>

<script>
import { reactive, toRefs, inject } from 'vue';
import { postSSOInput } from '@/apis/ssoInput';

export default {
    setup() {
        const $vfm = inject('$vfm');
        const users = reactive({
            id: 'A224757410',
            aplCatl: '',
            sysAuthCode: '',
            transactionItemNo: '',
            policyNo: '',
            policySeq: '',
            idDup: '',
            srceFrom: '',
            action: '',
            noErrorMsg: '',
            source: 'SCV',
            isLoading: false,
        });

        const postApi = async (canPost) => {
            if (canPost) {
                users.isLoading = true;
                const path = process.env.VUE_APP_API_PATH;
                const baseUrl = `${window.location.origin}${path}`;
                const data = {
                    id: users.id,
                    aplCatl: users.aplCatl,
                    source: users.source,
                    sysAuthCode: users.sysAuthCode,
                    transactionItemNo: users.transactionItemNo,
                    policyNo: users.policyNo,
                    policySeq: users.policySeq,
                    idDup: users.idDup,
                    srceFrom: users.srceFrom,
                    action: users.action,
                    a4: null,
                    a5: null
                };
                postSSOInput(data).then(res => {
                    window.location.href = `${baseUrl}/ssoLogin?param=${res.data.token}`;
                }).catch(err => {
                    openPopup(err.data?.errorMessage);
                }).finally(() => {
                    users.isLoading = false;
                });
            }
        };

        const openPopup = (errorMessage) => {
            $vfm.show({
                component: 'DialogBase',
                params: {
                    title: '系統提示',
                    content: errorMessage || '系統忙碌中，請稍後再試',
                    confirmButton: '確認',
                    cancelButton: null,
                    closeicon: true,
                },
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    },
                }
            });
        };

        return {
            ...toRefs(users),
            postApi
        };
    },
};
</script>
